/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AdminClientListCompletedOnboardingStepsInner } from './AdminClientListCompletedOnboardingStepsInner';
import {
    AdminClientListCompletedOnboardingStepsInnerFromJSON,
    AdminClientListCompletedOnboardingStepsInnerFromJSONTyped,
    AdminClientListCompletedOnboardingStepsInnerToJSON,
} from './AdminClientListCompletedOnboardingStepsInner';

/**
 * 
 * @export
 * @interface AdminClientList
 */
export interface AdminClientList {
    /**
     * 
     * @type {string}
     * @memberof AdminClientList
     */
    readonly userId?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminClientList
     */
    readonly fullName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminClientList
     */
    nonClient: boolean;
    /**
     * 
     * @type {Array<AdminClientListCompletedOnboardingStepsInner>}
     * @memberof AdminClientList
     */
    completedOnboardingSteps: Array<AdminClientListCompletedOnboardingStepsInner>;
}

/**
 * Check if a given object implements the AdminClientList interface.
 */
export function instanceOfAdminClientList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "nonClient" in value;
    isInstance = isInstance && "completedOnboardingSteps" in value;

    return isInstance;
}

export function AdminClientListFromJSON(json: any): AdminClientList {
    return AdminClientListFromJSONTyped(json, false);
}

export function AdminClientListFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminClientList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': !exists(json, 'user_id') ? undefined : json['user_id'],
        'fullName': !exists(json, 'full_name') ? undefined : json['full_name'],
        'nonClient': json['non_client'],
        'completedOnboardingSteps': ((json['completed_onboarding_steps'] as Array<any>).map(AdminClientListCompletedOnboardingStepsInnerFromJSON)),
    };
}

export function AdminClientListToJSON(value?: AdminClientList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'non_client': value.nonClient,
        'completed_onboarding_steps': ((value.completedOnboardingSteps as Array<any>).map(AdminClientListCompletedOnboardingStepsInnerToJSON)),
    };
}

